import { useTranslate } from "@made-people/grease-translations";
import { useLink } from "@made-people/grease-link";

export const UnimplementedRoute = () => {
  const translate = useTranslate();
  const Link = useLink();
  return (
    <div className="flex min-h-[60vh] items-center justify-center px-4 py-16">
      <div className="flex max-w-md flex-col items-center text-center">
        <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-mandy-100">
          <svg
            className="h-10 w-10 text-mandy-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={1.5}
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M11.42 15.17L17.25 21A2.652 2.652 0 0021 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 11-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 004.486-6.336l-3.276 3.277a3.004 3.004 0 01-2.25-2.25l3.276-3.276a4.5 4.5 0 00-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437l1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008z"
            />
          </svg>
        </div>

        <h1 className="mb-3 font-primary text-heading-lg text-black">
          {translate("UnimplementedRoute_Title")}
        </h1>

        <p className="mb-6 font-primary text-body-md text-neutral-600">
          {translate("UnimplementedRoute_Text")}
        </p>

        <div className="flex items-center gap-2 rounded-full bg-beige-100 px-4 py-2">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-mandy-400 opacity-75" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-mandy-500" />
          </span>
          <span className="font-primary text-body-sm text-neutral-700">
            {translate("UnimplementedRoute_Badge")}
          </span>
        </div>

        <Link
          href=""
          className="mt-8 inline-flex items-center gap-2 font-primary text-body-md text-mandy-600 underline-offset-4 transition-colors hover:text-mandy-700 hover:underline focus:outline-none focus:ring-2 focus:ring-mandy-500 focus:ring-offset-2"
          tabIndex={0}
          aria-label="Return to homepage"
        >
          <svg
            className="h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
            />
          </svg>
          {translate("UnimplementedRoute_BackToShopping")}
        </Link>
      </div>
    </div>
  );
};
